import { api } from '@/utils/api';

export interface UnitHit {
  id: string;
  code: string;
  product?: { name?: string | null } | null;
}

export interface CustomerFill {
  customerName?: string;
  customerPhone?: string;
  customerAddress?: string;
}

/** Unit search for a service ticket. The server route is /product-units and filters on `code`. */
export async function searchProductUnits(q: string): Promise<UnitHit[]> {
  const r = await api.get('/product-units', { params: { code: q, limit: 20 } });
  const rows = r.data?.data;
  return Array.isArray(rows) ? rows : [];
}

const clean = (v: unknown): string | undefined => (typeof v === 'string' && v.trim() ? v.trim() : undefined);

/** What the picked unit (and its warranty) already holds about the customer. Missing = left out, never guessed. */
export function customerFromUnit(
  unit: { installLocation?: string | null } | null | undefined,
  warranty: { contactName?: string | null; customerName?: string | null; contactPhone?: string | null; customerPhone?: string | null; account?: { name?: string | null } | null } | null | undefined,
): CustomerFill {
  const fill: CustomerFill = {};
  const name = clean(warranty?.contactName) ?? clean(warranty?.customerName) ?? clean(warranty?.account?.name);
  const phone = clean(warranty?.contactPhone) ?? clean(warranty?.customerPhone);
  const address = clean(unit?.installLocation);
  if (name) fill.customerName = name;
  if (phone) fill.customerPhone = phone;
  if (address) fill.customerAddress = address;
  return fill;
}

/** Full unit by code + the warranty registered on its serial number (if any). */
export async function loadUnitCustomer(code: string): Promise<CustomerFill> {
  const u = await api.get(`/product-units/${encodeURIComponent(code)}/lookup`);
  const unit = u.data?.data;
  let warranty = null;
  if (unit?.serialNumber) {
    try {
      const w = await api.get('/warranties', { params: { search: unit.serialNumber, limit: 5 } });
      const rows: any[] = Array.isArray(w.data?.data) ? w.data.data : [];
      warranty = rows.find((r) => r.serialNumber === unit.serialNumber) ?? null;
    } catch { /* warranty list may be closed to this role: use the unit alone */ }
  }
  return customerFromUnit(unit, warranty);
}
